import ClubDunningSettings from '../dto/ClubDunningSettings';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubDunningSettingsRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/dunning-settings`)
                .then((response) => resolve(ClubDunningSettings.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubIdFromDummy(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/dunning-settings`)
                .then((response) => resolve(ClubDunningSettings.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, clubDunningSettings) {
        clubDunningSettings.invoicePaymentDeadline = Number(clubDunningSettings.invoicePaymentDeadline);
        if (clubDunningSettings.invoicePaymentDeadline === 0) {
            clubDunningSettings.invoicePaymentDeadline = null;
        }

        const data = {
            invoicePaymentDeadline: clubDunningSettings.invoicePaymentDeadline,
            clubDunningLevel1: clubDunningSettings.clubDunningLevel1.serialize(),
            clubDunningLevel2: clubDunningSettings.clubDunningLevel2.serialize(),
            clubDunningLevel3: clubDunningSettings.clubDunningLevel3.serialize(),
            clubDunningLevel4: clubDunningSettings.clubDunningLevel4.serialize(),
            clubFeeCategoryId: clubDunningSettings.clubFeeCategory !== null ? clubDunningSettings.clubFeeCategory.id : null,
            clubFeeForChargebackId: clubDunningSettings.clubFeeForChargeback !== null ? clubDunningSettings.clubFeeForChargeback.id : null,
            chargebackPdfText: clubDunningSettings.chargebackPdfText,
            chargebackPdfTextFooter: clubDunningSettings.chargebackPdfTextFooter,
            chargebackShowBankDetails: clubDunningSettings.chargebackShowBankDetails,
            enabled: clubDunningSettings.enabled,
        };
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/dunning-settings`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
